import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import Homepage from './components/Login/Homepage';
import ResetPassword from './components/Login/ResetPassword';
import TypeUser from './components/Login/TypeUser';
import ProtectedRoute from './components/Protected/ProtectedRoute';
import Register from './components/Register/RegisterComponent';
import { PrivateRoute } from './PrivateRoute';
import pckjson from '../package.json';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    console.log('version: ', pckjson.version);
  }

  render() {
    return (
      <div id="rootWrapper">
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Homepage} />
            <Route exact path="/typeuser" component={TypeUser} />
            {/* <Route exact path="/login" component={Login} /> */}
            <Route exact path="/resetpassword" component={ResetPassword} />

            <Route exact path="/register" component={Register} />

            <PrivateRoute exact path="/:env/:page" component={ProtectedRoute} />

          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js